import React, { useState, useEffect } from "react";
import { Typography, Box } from "@material-ui/core";
import { IntroText, CheckboxList, FormActionDrawer } from "../../../components";
import { useHeader } from "../../../contexts";
import { useTranslation } from "react-i18next";

const OptionsData = [
  {
    value: "race_american_indian",
    label_translation_key: "schedule.race.options.race_american_indian"
  },
  {
    value: "race_asian",
    label_translation_key: "schedule.race.options.race_asian"
  },
  {
    value: "race_black",
    label_translation_key: "schedule.race.options.race_black"
  },
  {
    value: "race_white",
    label_translation_key: "schedule.race.options.race_white"
  },
  {
    value: "race_hawaiian",
    label_translation_key: "schedule.race.options.race_hawaiian"
  },
  {
    value: "other",
    label_translation_key: "schedule.race.options.other"
  }
];

const ScheduleRace = ({
  setDrawerClearance,
  updateScheduleData,
  scheduleData,
  isSubmitting
}) => {
  const { t } = useTranslation();
  const { setTitle } = useHeader();
  const [race, setRace] = useState();
  const [error, setError] = useState(false);

  useEffect(() => {
    setTitle(t("schedule.race.title"));
  }, []);

  const handleNext = () => {
    if (race && race.length > 0) {
      updateScheduleData({ race });
    } else {
      setError(true);
    }
  };

  return (
    <Box data-cy="schedule-screen-race">
      <IntroText>{t("schedule.race.intro_text")}</IntroText>
      {error && (
        <Typography color="error">{t("schedule.race.error")}</Typography>
      )}
      <CheckboxList
        options={OptionsData}
        onChange={setRace}
        initialValues={scheduleData.race}
      />
      <FormActionDrawer
        setDrawerClearance={setDrawerClearance}
        handleNext={e => handleNext()}
        loading={isSubmitting}
      />
    </Box>
  );
};

export { ScheduleRace };
